import React from "react";
import axios from "axios";
import { useState, useEffect, useContext } from "react";
import SglContext from "../SglContext";
import indicator_icon from "../images/Indicator.gif";
import "./forgotPasswordForm.css";
import PasswordStrengthMeter from "../common/PasswordStrengthMeter"


export default function PasswordVerificationForm() {
  const [email, set_email] = useState("");
  const [hashkey, set_hashkey] = useState("");
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");

  const Sgl = useContext(SglContext);

  //API END POINTS
  const sgl_webservice_password_verification =
    Sgl.sglApiUrl + "/iphone.php/webservice/PasswordVerification";
  const sgl_webservice_process_password_verification =
    Sgl.sglApiUrl +
    "/iphone.php/webservice/ProcessPasswordVerification";

  useEffect(() => {
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    let sgl_plugin_error_message = document.getElementById(
      "sgl-plugin-error-message"
    );
    let sgl_plugin_success_message = document.getElementById(
      "sgl-plugin-success-message"
    );

    axios
      .all([
        axios.get(sgl_webservice_password_verification, {
          params: {
            customer_id: Sgl.company_id,
            key: getQueryVariable("key"),
          },
        }),
      ])
      .then(
        axios.spread((response) => {
          if (response.data.status) {
            setLoading(false);
            set_email(response.data.email);
            set_hashkey(response.data.hashkey);
            sgl_plugin_form.style.display = "block";
            sgl_plugin_success_message.style.display = "none";
            sgl_plugin_error_message.style.display = "none";
          } else {
            sgl_plugin_form.innerHTML = "";
            sgl_plugin_form.style.display = "none";
            sgl_plugin_success_message.style.display = "none";
            sgl_plugin_error_message.innerHTML = response.data.message;
            sgl_plugin_error_message.style.display = "block";
          }
        })
      );
  }, []);

  let handlePasswordChange = event => {
    setPassword(event.target.value)
  } 

  function processPasswordVerification() {
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    let sgl_plugin_error_message = document.getElementById(
      "sgl-plugin-error-message"
    );
    let sgl_plugin_success_message = document.getElementById(
      "sgl-plugin-success-message"
    );
    let errorContainer = document.getElementById("reg_error_summary");

    let email = document.getElementById("email");
    let pass = document.getElementById("pass");
    let conf_pass = document.getElementById("conf_pass");

    errorContainer.innerHTML = "";
    errorContainer.style.display = "none";

    axios
      .post(sgl_webservice_process_password_verification, null, {
        params: {
          email: email.value,
          pass: pass.value,
          conf_pass: conf_pass.value,
          customer_id: Sgl.company_id,
          hashkey: hashkey,
        },
      })
      .then((response) => {
        if (response.data.status) {
          sgl_plugin_form.innerHTML = "";
          sgl_plugin_form.style.display = "none";
          sgl_plugin_success_message.style.display = "block";
        } else {
          errorContainer.innerHTML = response.data.message;
          errorContainer.style.display = "block";
        }
      });
  }

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  if (loading) {
    return null;
  }

  return (
    <div className='sgl-content-wrapper forgotPasswordformcss'>
      <div className='sgl-plugin'>
        <div className='forgot_password_header'>
          <h1>FORGOT PASSWORD</h1>
        </div>

        {/* form start */}
        <div id='sgl-plugin-form' style={{ display: "block" }}>
          <div className='div-responsive'>
            <div className='forgot-password-container'>
              <div className='fp_message'>
                <div>
                  <p> Please fill the form to reset your account password.</p>
                </div>
              </div>

              <div className='full'>
                <input
                  type='text'
                  placeholder='Email'
                  name='email'
                  id='email'
                  value={email}
                />
              </div>

              <div className='full'>
                <div className='half'>
                  <input
                    type='password'
                    placeholder='Password'
                    id='pass'
                    name='pass'
                    onChange={handlePasswordChange}
                  />
                  { password && <PasswordStrengthMeter password={password} /> }
                </div>

                <div className='half'>
                  <input
                    type='password'
                    placeholder='Confirm Password'
                    name='conf_pass'
                    id='conf_pass'
                  />
                </div>
              </div>

              <div className='error_container'>
                <div>
                  <p
                    className='error_summary reg_error_summary'
                    id='reg_error_summary'></p>
                </div>
              </div>

              <div className='full submit'>
                <input
                  type='button'
                  id='update'
                  className='button'
                  onClick={processPasswordVerification}
                  value='Submit'
                />
                <span id='please-wait'>
                  <img src={indicator_icon} /> Verifiying...
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* form end */}

        <div id='sgl-plugin-error-message'></div>

        <div id='sgl-plugin-success-message'>
          <p>
            <b>Password Changed</b>
            <br />
            Your password has been changed successfully.
          </p>
        </div>
      </div>
    </div>
  );
}
